import { render, staticRenderFns } from "./MontagemCargaTransportadoraForm.vue?vue&type=template&id=6797e980"
import script from "./MontagemCargaTransportadoraForm.vue?vue&type=script&lang=js"
export * from "./MontagemCargaTransportadoraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports